{
  "version": 1,
  "asset_id": "46a83895-a52d-46ad-99fe-d04523b45f29",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/46a83895-a52d-46ad-99fe-d04523b45f29/lecanto-metal-roof-after-1200w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/46a83895-a52d-46ad-99fe-d04523b45f29/lecanto-metal-roof-after-1200w.webp",
  "original_filename": "lecanto-metal-roof-after-1200w.webp",
  "size": 250092,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:57Z"
}
